// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"172":"e9c52853","5545":"e9c52853"}[chunkId] + ".chunk.css";
};